import { useEffect, useRef } from "react";

// Decisión de medición: GA4 se carga directo (gtag.js, G-48ZV0PXBZV) y GTM
// (GTM-WGXHV479) se usa solo como dataLayer para futuras etiquetas.
// NO creamos una Google Tag de GA4 dentro de GTM desde código, para evitar
// page_views/eventos duplicados. Los eventos van a AMBOS: gtag (GA4 directo)
// y dataLayer (GTM). No se envían datos personales: solo identificadores de CTA.
export function track(name, params = {}) {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") {
        window.gtag("event", name, params);
    }
}

export function useViewEvent(name) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const ob = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    track(name);
                    ob.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        ob.observe(el);
        return () => ob.disconnect();
    }, [name]);
    return ref;
}
